import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesTabComponent } from './messages-tab.component';
import { SharedModule } from '@shared/shared.module';
import { GalleryModule } from '@app/gallery/gallery.module';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ScheduleMessageModalComponent } from './schedule-message-modal/schedule-message-modal.component';
import { ScheduledMessagesModalComponent } from './scheduled-messages-modal/scheduled-messages-modal.component';
import { ChatRoomDetailsSidebarModule } from '@shared/components/chat-room-details-sidebar/chat-room-details-sidebar.module';
// Note: ResolutionCenterService is provided in root, so we don't need to import ResolutionCenterModule

/**
 * Standalone MessagesTabModule
 * Can be imported into any module without routing conflicts
 */
@NgModule({
    declarations: [
        MessagesTabComponent,
        ScheduleMessageModalComponent,
        ScheduledMessagesModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        GalleryModule,
        PickerModule,
        BsDatepickerModule.forRoot(),
        ModalModule.forRoot(),
        ChatRoomDetailsSidebarModule
    ],
    exports: [MessagesTabComponent]
})
export class MessagesTabModule { }


